import type { IOrganizationFeatureEDocSignatures } from './OrganizationFeatureEDocSignatures.interface';

export default class OrganizationFeatureEDocSignatures
  implements IOrganizationFeatureEDocSignatures {
  signaturesRemaining: number;
  automaticallyRecharge: boolean;
  rechargeWhenSignaturesRemainingReach: number;

  static build = (data: IOrganizationFeatureEDocSignatures) =>
    new OrganizationFeatureEDocSignatures(data);
  static blank = () => new OrganizationFeatureEDocSignatures();

  /**
   * Constructor
   * @param {IOrganizationFeatureEDocSignatures} data
   */
  constructor(data?: IOrganizationFeatureEDocSignatures) {
    this.signaturesRemaining = parseInt(data?.signaturesRemaining || 0, 10);
    this.automaticallyRecharge = data?.automaticallyRecharge === true;
    this.rechargeWhenSignaturesRemainingReach = parseInt(
      data?.rechargeWhenSignaturesRemainingReach || 0,
      10
    );
  }
}
